const units = {
  g: {
    display: 'g',
    factors: {
      kg: 0.001
    }
  },
  kg: {
    display: 'kg',
    factors: {
      g: 1000
    }
  },
  l: {
    display: 'l',
    factors: {
      ml: 1000
    }
  },
  ml: {
    display: 'ml',
    factors: {
      l: 0.001
    }
  },
  u: {
    display: 'ud.'
  },
  // Volume-ish kitchen units. Typical volumes let aggregation convert
  // them if it ever needs to, but display stays in spoons.
  cucharada: {
    display: 'cda.',
    factors: {
      ml: 15,
      l: 0.015
    }
  },
  cucharadita: {
    display: 'cdta.',
    factors: {
      ml: 5,
      l: 0.005
    }
  },
  pizca: {
    display: 'pizca'
  },
  alGusto: {
    display: 'al gusto',
    amountless: true
  }
}

function asNumber(value) {
  const parsed = parseFloat(value)

  return isNaN(parsed) ? null : parsed
}

/**
 * The amountRange form field holds { amount, amountMax } (legacy
 * values are plain numbers). This flattens either shape into clean
 * numeric amount/amountMax pairs for the mutations.
 */
export function flattenAmountRange(value) {
  if (value && typeof value == 'object') {
    return {
      amount: asNumber(value.amount),
      amountMax: asNumber(value.amountMax)
    }
  }

  return {
    amount: asNumber(value),
    amountMax: null
  }
}

export function unitDisplay(unit) {
  const info = units[unit]

  return info ? info.display : (unit || '')
}

export function isAmountless(unit) {
  const info = units[unit]

  return Boolean(info && info.amountless)
}

/**
 * Human text for an amount + unit pair, range aware («2–3 ud.»).
 * Amountless units ("al gusto") show just the unit, missing data
 * degrades gracefully instead of printing "undefined undefined".
 */
export function amountText(amount, unit, amountMax) {
  if (isAmountless(unit))
    return unitDisplay(unit)

  const value = parseFloat(amount)
  if (isNaN(value))
    return unitDisplay(unit)

  const max = parseFloat(amountMax)
  const range = isNaN(max) || max == value ? `${value}` : `${value}–${max}`

  return `${range} ${unitDisplay(unit)}`
}

export function asSelectOptions() {
  let options = []
  for (let k in units) {
    let unit = units[k]
    options.push({
      value: k,
      label: unit.display
    })
  }

  return options
}

export function valuesAsArray() {
  return Object.keys(units)
}

export function convertData(data, toUnit) {
  const { value, unit } = data

  return convertUnit(value, unit, toUnit)
}

export function convertUnit(strVal, unit, toUnit) {
  const value = parseFloat(strVal)

  if (unit == toUnit) {
    return {
      value,
      unit
    }
  } else {
    const unitInfo = units[unit]
    const { factors } = unitInfo

    if (factors && factors[toUnit]) {
      return {
        value: value * factors[toUnit],
        unit: toUnit
      }
    }
  }
}
